import { PlanMetadataTypes } from '@mode/shared/contract-common';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPlanMetadata from './plan-metadata.reducer';

export const selectPlanMetadataState = createFeatureSelector<fromPlanMetadata.PlanMetadataFeatureState>(
  fromPlanMetadata.planMetadataFeatureKey
);

export const selectPlanPaging = createSelector(selectPlanMetadataState, (feature) => feature.paging);

export const getPlanPagings = createSelector(selectPlanPaging, fromPlanMetadata.planPagingSelectAll);

export const getPlanPagingEntities = createSelector(selectPlanPaging, fromPlanMetadata.planPagingSelectEntities);

export const getPlanPagingByMetadataId = (planMetadataId: PlanMetadataTypes.PlanMetadataId) =>
  createSelector(getPlanPagingEntities, (entities) => entities[planMetadataId]);

export const getOffsetByMetadataId = (planMetadataId: PlanMetadataTypes.PlanMetadataId) =>
  createSelector(getPlanPagingByMetadataId(planMetadataId), (planPaging) => {
    if (planPaging) {
      return planPaging.offset;
    }

    return;
  });

export const getPageSizeByMetadataId = (planMetadataId: PlanMetadataTypes.PlanMetadataId) =>
  createSelector(getPlanPagingByMetadataId(planMetadataId), (planPaging) => {
    if (planPaging) {
      return planPaging.pageSize;
    }

    return;
  });
